import React from 'react'

import MaskedPhoneField from './MaskedPhoneField'

function FormPhone(props) {
  return (
    <MaskedPhoneField {...props} />
  )
}

export default FormPhone